export function searchIsConflicted(vicciData) {
    var _a;
    return ((_a = vicciData === null || vicciData === void 0 ? void 0 : vicciData.validationData) === null || _a === void 0 ? void 0 : _a.conflicted) || false;
}
export function searchCarlineId(vicciData) {
    var _a;
    return ((_a = vicciData === null || vicciData === void 0 ? void 0 : vicciData.vehicleConfiguration) === null || _a === void 0 ? void 0 : _a.carlineKey) || '';
}
export function searchExteriorId(vicciData) {
    var _a, _b;
    return ((_b = (_a = vicciData === null || vicciData === void 0 ? void 0 : vicciData.vehicleConfiguration) === null || _a === void 0 ? void 0 : _a.exterior) === null || _b === void 0 ? void 0 : _b.code) || '';
}
export function searchOptionIds(vicciData) {
    var _a, _b;
    return (((_b = (_a = vicciData === null || vicciData === void 0 ? void 0 : vicciData.vehicleConfiguration) === null || _a === void 0 ? void 0 : _a.features) === null || _b === void 0 ? void 0 : _b.map((f) => f.code)) || []);
}
export function searchInteriorId(vicciData) {
    var _a, _b;
    return ((_b = (_a = vicciData === null || vicciData === void 0 ? void 0 : vicciData.vehicleConfiguration) === null || _a === void 0 ? void 0 : _a.interior) === null || _b === void 0 ? void 0 : _b.code) || '';
}
export function searchModelId(vicciData) {
    var _a;
    return ((_a = vicciData === null || vicciData === void 0 ? void 0 : vicciData.vehicleConfiguration) === null || _a === void 0 ? void 0 : _a.modelKey) || '';
}
export function searchModelYear(vicciData) {
    var _a;
    return ((_a = vicciData === null || vicciData === void 0 ? void 0 : vicciData.vehicleConfiguration) === null || _a === void 0 ? void 0 : _a.modelYear) || '';
}
export function searchModelVersion(vicciData) {
    var _a;
    return ((_a = vicciData === null || vicciData === void 0 ? void 0 : vicciData.vehicleConfiguration) === null || _a === void 0 ? void 0 : _a.modelVersion) || '';
}
export function searchSalesGroupId(vicciData) {
    var _a;
    return ((_a = vicciData === null || vicciData === void 0 ? void 0 : vicciData.vehicleConfiguration) === null || _a === void 0 ? void 0 : _a.salesgroupKey) || '';
}
export function searchTrimName(vicciData) {
    var _a, _b;
    return (((_b = (((_a = vicciData === null || vicciData === void 0 ? void 0 : vicciData.vehicleConfiguration) === null || _a === void 0 ? void 0 : _a.modelFilters) || []).find((model) => model.type === 'EquipmentLine')) === null || _b === void 0 ? void 0 : _b.text) || '');
}
